import { ComponentType, FC } from "react";
import { AvailableSidebarContentType, ContentTypeData } from "../../store/sidebar-store";
import { ContactDetailsSidebarContent } from "./ContactDetailsSidebarContent";

export const SIDEBAR_PANEL_CONTENT_COMPONENT_MAP = {
  ContactDetails: ContactDetailsSidebarContent,
} as const satisfies {
  [C in AvailableSidebarContentType]:
    | FC<NonNullable<ContentTypeData[C]>>
    | ComponentType<NonNullable<ContentTypeData[C]>>;
};
